query GetDafInvestmentAllocationChanges($fundId: ID, $page: Int, $limit: Int) {
  dafInvestmentAllocationChanges(fundId: $fundId, page: $page, limit: $limit) {
    collection {
      id
      fund {
        id
        name
      }
      dateApplied
      effectiveDate
      dateCreated
      dateUpdated
      newInvestmentAllocation
      status
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
